import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName = 'Relatorio', sheetName = 'Dados', merges = []) => {
    if (!data || data.length === 0) {
        console.warn("Nenhum dado fornecido para exportação.");
        return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    
    if (merges.length > 0) {
        worksheet['!merges'] = merges;
    }

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};